import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, FileText, Clock, Infinity as InfinityIcon } from 'lucide-react';
export function ProductIntro() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto text-center" data-id="element-282">
      <motion.div initial={{
      opacity: 0,
      scale: 0.9
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8
    }} data-id="element-283">
        <ShieldCheck className="w-20 h-20 text-[#d4af37] mx-auto mb-8 opacity-80" data-id="element-284" />

        <h2 className="text-3xl md:text-5xl font-bold text-white font-heading mb-4" data-id="element-285">
          MÉTODO ELITE AT
        </h2>
        <h3 className="text-xl md:text-2xl text-gold-gradient font-medium mb-12" data-id="element-286">
          El Sistema 360 de Gestión Clínica
        </h3>

        <div className="space-y-4 text-xl md:text-2xl text-[#e2e8f0] font-light mb-12" data-id="element-287">
          <p data-id="element-288">No es un curso.</p>
          <p data-id="element-289">No es teoría.</p>
          <p data-id="element-290">No es normativa resumida.</p>
          <p className="text-white font-medium mt-6 text-2xl md:text-3xl" data-id="element-291">
            Es tu sistema operativo profesional.
          </p>
          <p className="text-gold-gradient font-bold text-2xl md:text-3xl" data-id="element-292">
            Tu protocolo. Tu escudo.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-4 md:gap-8 mt-12" data-id="element-293">
          <div className="flex items-center gap-2 bg-[#0f1d36] border border-[#1a2b4c] rounded-full px-6 py-3" data-id="element-294">
            <FileText className="w-5 h-5 text-[#d4af37]" data-id="element-295" />
            <span className="text-white font-medium" data-id="element-296">100% PDF</span>
          </div>
          <div className="flex items-center gap-2 bg-[#0f1d36] border border-[#1a2b4c] rounded-full px-6 py-3" data-id="element-297">
            <Clock className="w-5 h-5 text-[#d4af37]" data-id="element-298" />
            <span className="text-white font-medium" data-id="element-299">Acceso inmediato</span>
          </div>
          <div className="flex items-center gap-2 bg-[#0f1d36] border border-[#1a2b4c] rounded-full px-6 py-3" data-id="element-300">
            <InfinityIcon className="w-5 h-5 text-[#d4af37]" data-id="element-301" />
            <span className="text-white font-medium" data-id="element-302">Tuyo de por vida</span>
          </div>
        </div>
      </motion.div>
    </section>;
}